import { useSelectionURLSync } from "../../hooks/useSelectionURLSync";

// useSelectionURLSync handles all URL ↔ store sync
// including deep-linking, browser back/forward, and the initial endpoint default.

export default function AppBootstrapper() {
  useSelectionURLSync();
  return null;
}
